export default __webpack_public_path__ + "static/media/privacy-preserving.8e9f1d16.png";